module.exports = __webpack_public_path__ + "img/IMG-20200809-WA0017.61753ca7.jpg";